export const isNullish = (x: unknown): x is null | undefined => {
  return typeof x === 'undefined' || x === undefined || x === null;
};
